import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu
} from "reactstrap";
import classNames from "classnames";

import MaterialIcon from "./MaterialIcon";

const Kebab = ({ children, direction, right, className, horizontal, disabled, onToggled, ...props }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => {
    const toggleValue = !dropdownOpen;
    setDropdownOpen(toggleValue);
    onToggled && onToggled(toggleValue);
  };
  const iconDirection = horizontal ? "more_horiz" : "more_vert";

  return (
    <Dropdown
      className={className}
      direction={direction}
      isOpen={dropdownOpen}
      toggle={toggle}
      disabled={disabled}
      {...props}
    >
      <DropdownToggle tag="button" className={classNames("btn btn-actions-menu", { 'disabled': disabled })}>
        <MaterialIcon name={iconDirection} />
      </DropdownToggle>
      <DropdownMenu right={right}>{children}</DropdownMenu>
    </Dropdown>
  );
};

Kebab.defaultProps = {
  direction: "left",
  horizontal: false,
  right: false,
  disabled: false
};

Kebab.propTypes = {
  /**
   * the dropdown items.
   *  */
  children: PropTypes.node.isRequired,
  /**
   * the direction in which the menu will open
   *  */
  direction: PropTypes.string,
  /**
   * prop that aligns dropdown menu to the right
   *  */
  right: PropTypes.bool,
  /**
   * the class to apply to the dropdown menu
   *  */
  className: PropTypes.string,
  /**
   * orient the icon to be horizontal (defaults to false)
   *  */
  horizontal: PropTypes.bool,
  /**
   * determies if the DropdownToggle should apply the disabled class (defaults to false)
   *  */
  disabled: PropTypes.bool,
  /**
   * Function that is called when the kebab dropdown is opened and closed.
   * Should accept a single "open" argument that indicates whether the dropdown has been toggled open or closed.
   *  */
  onToggled: PropTypes.func
};

export default Kebab;
